import { ReactElement, ReactNode } from 'react'

export interface RenderIfProps {
    children: ReactNode
    condition: boolean
}
export function RenderIf({ children, condition }: RenderIfProps): ReactElement {
    return <>{condition && children}</>
}
